import React from "react";

const aastha_jajoo = () => {
  return (
    <div>
      <h1>Aastha Jajoo</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Eligible for online aptitude-
      </p>

      <ul>
        <li>Branch: Computer </li>
        <li>CGPA: 7+ and no backlogs</li>
      </ul>

      <p>
        Based on performance in aptitude students were shortlisted for
        interviews.{" "}
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        There were 10+ interview panels thus the process was quite fast. First
        technical round began by 9 AM, second technical by 12PM and HR
        interviews were completed by 2PM.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The online aptitude test was conducted from college premises.
        <br />
        <strong>Duration</strong> : 90 min
        <br />
        <strong>2 sections :</strong>{" "}
      </p>

      <ol>
        <li>
          <strong>MCQ</strong> based on:
          <ol>
            <li>OS- scheduling </li>
            <li>CN- subnetting, DNS </li>
            <li>DBMS- postgreSQL query, normalisation </li>
            <li>DSA- time complexities of pseudocodes provided by them </li>
            <li>OOP basic concepts </li>
            <li>HTML/CSS code was given and had to match the output </li>
          </ol>
        </li>
        <li>
          <strong>2 Coding</strong> questions worth 20 marks and 50 marks each
          (based on graphs).
        </li>
      </ol>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        22
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The aptitude test was conducted on 29th July, the shortlist was released
        later that night around 11PM .The interviews were scheduled for the next
        morning (30th July) from 9 AM onwards. During this brief amount of time,
        I revisited my projects, ensuring I knew every detail of them including
        tech stacks.{" "}
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were 3 rounds:
      </p>

      <ol>
        <li>
          <strong>Technical 1 (30 mins):</strong>
          <br />I was asked in-depth questions on DBMS (writing SQL queries,
          predicting outputs and explaining database concepts). I was also asked
          to code a problem on paper. The interviewer asked me questions based
          on statistics and machine learning although they weren't explicitly
          mentioned on my resume.{" "}
        </li>
        <li>
          <strong>Technical 2 (30-40 mins):</strong>
          <br />I was asked detailed questions on my previous internship
          experience and projects, DSA questions based on stack, queue, linked
          list and graphs, a standard sliding window problem from LeetCode, OOP
          concepts, memory management in C vs Java, fundamentals of OS and DBMS.{" "}
        </li>
        <li>
          <strong>HR (15 mins):</strong>
          <br />I was asked to describe the process of making tea (to check my
          fluency in English). Describe a situation where I faced a setback and
          how I overcame it. How I resolve team conflicts as a team leader. My
          greatest strength. My public speaking experiences.{" "}
        </li>
      </ol>

      <p>
        After the first technical round, 14 were shortlisted. 9 were shortlisted
        for the HR round. 7 were given the final offer.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        OOPs, DBMS, DSA, OS
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <ol>
        <li>
          DSA:
          <ol>
            <li>
              Leetcode-{" "}
              <a href="https://leetcode.com/studyplan/top-interview-150/">
                Top interview 150
              </a>{" "}
            </li>
            <li>
              <a href="https://takeuforward.org/interviews/strivers-sde-sheet-top-coding-interview-problems">
                Striver’s SDE sheet
              </a>{" "}
            </li>
          </ol>
        </li>
        <li>
          OOP (prefer Java in my opinion):{" "}
          <a href="https://www.tpointtech.com/java-tutorial">Javatpoint</a>{" "}
        </li>
        <li>
          DBMS:{" "}
          <a href="https://youtube.com/playlist?list=PLDzeHZWIZsTpukecmA2p5rhHM14bl2dHU&si=tZnDUBfuq_jQgx-u">
            CodeHelp DBMS Placement Series
          </a>{" "}
        </li>
        <li>
          OS:{" "}
          <a href="https://www.youtube.com/playlist?list=PLDzeHZWIZsTr3nwuTegHLa2qlI81QweYG">
            CodeHelp OS Placement Series
          </a>
        </li>
      </ol>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practice a diverse range of coding problems (different approaches to the
        same problem). In interviews, ensure you fully understand the question.
        Don’t hesitate to ask clarifying questions if anything is unclear. While
        explaining the approach, think aloud, start with a brute-force approach,
        then gradually optimize it to show your problem solving approach.{" "}
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        In my technical round 2, I was asked in depth about my projects-
        workflow, tech stack (why a particular one over the other),
        constraints/challenges faced and how I overcame them. We also discussed
        the hackathons I had mentioned in my extra curricular activities. While
        the HR round revolved around my clubs. Being events lead at Software
        Development Section (SDS) I was asked to explain what all parameters I
        consider while planning an event; due to space restriction on resume, I
        couldn't mention all club activities I had been a part of but I did talk
        about them during the interview.{" "}
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Technical interviews were quite resume driven so make sure to know every
        bit of your resume. Avoid using technical terms you aren’t confident
        about. And if you don’t know a certain answer, be honest about it rather
        than faking/guessing it. For HR, try to give real-life instances to
        support your answers. Also, pay attention during the PPT, try to align
        your answers with the firm's core values.{" "}
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Be calm and confident. Hone your communication skills. Start early. All
        the best :)
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:aasthaj23.comp@coeptech.ac.in">aasthaj23.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/aastha-j/">Aastha Jajoo</a>
      </p>
    </div>
  );
};

export default aastha_jajoo;
